export default {"src":"/login-app/[GIT_HASH]/_next/static/media/folder_match.37d894a1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};